import { useState } from 'react';
import { DeliveryFormData } from '../components/DeliveryForm';

export const MINIMUM_CARD_VALUE = 10;
export const MAX_ITEM_COUNT = 4;
export const BULK_ITEM_COUNT = 12;
export const MANY_ITEMS_SURCHARGE = 0.5;
export const BULK_FEE = 1.2;

export const MINIMUM_DISTANCE_DELIVERY_FEE = 2;
export const MINIMUM_DISTANCE = 1000;
export const DISTANCE_STEPS = 500;

export const MAX_FEE = 15;
export const MAX_CARD_VALUE = 200;

export default function useDeliveryFee(): {
    fee: typeof fee;
    updateDeliveryData: (data: DeliveryFormData) => void;
} {
    const [fee, setFee] = useState<number | null>(null);

    const calculateFee = (data: DeliveryFormData): void => {
        if (data.cartValue >= MAX_CARD_VALUE) {
            setFee(0);
            return;
        }

        let fee =
            getBaseDeliveryFee(data.deliveryDistance) +
            getSmallOrderSurcharge(data.cartValue) +
            getItemCountSurcharge(data.numberOfItems) +
            getBulkItemsSurcharge(data.numberOfItems);

        if (isFridayRushHours(data.orderTime)) fee *= 1.2;

        fee = fee > MAX_FEE ? MAX_FEE : fee;

        setFee(Math.round(fee * 100) / 100);
    };

    const getSmallOrderSurcharge = (cartValue: number): number => {
        return cartValue < MINIMUM_CARD_VALUE
            ? MINIMUM_CARD_VALUE - cartValue
            : 0;
    };

    const getBaseDeliveryFee = (deliveryDistance: number): number => {
        return deliveryDistance > MINIMUM_DISTANCE
            ? MINIMUM_DISTANCE_DELIVERY_FEE +
                  Math.ceil(
                      (deliveryDistance - MINIMUM_DISTANCE) / DISTANCE_STEPS
                  )
            : MINIMUM_DISTANCE_DELIVERY_FEE;
    };

    const getItemCountSurcharge = (numberOfItems: number): number => {
        return numberOfItems > MAX_ITEM_COUNT
            ? (numberOfItems - MAX_ITEM_COUNT) * MANY_ITEMS_SURCHARGE
            : 0;
    };

    const getBulkItemsSurcharge = (numberOfItems: number): number => {
        return numberOfItems > BULK_ITEM_COUNT ? BULK_FEE : 0;
    };

    const isFridayRushHours = (orderTime: string): Boolean => {
        const deliveryDateTime = new Date(orderTime);
        const weekDay = deliveryDateTime.getDay();
        const hours = deliveryDateTime.getHours();
        const minutes = deliveryDateTime.getMinutes();

        if (weekDay === 5 && isTimeInRushHourRange(hours, minutes)) return true;
        else return false;
    };

    const isTimeInRushHourRange = (h: number, m: number): Boolean => {
        if (h >= 15 && h < 19) return true;
        if (h === 19 && m === 0) return true;
        return false;
    };

    return {
        fee,
        updateDeliveryData: calculateFee,
    };
}
